import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Box,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const columns = [
  {
    id: "id",
    label: "S.NO",
    minWidth: 170,
    align: "center",
  },
  {
    id: "points_for_wholesaler",
    label: "POINTS FOR WHOLESALER",
    minWidth: 170,
    align: "center",
  },
  {
    id: "points_for_retailer",
    label: "POINTS FOR RETAILER",
    minWidth: 100,
    align: "center",
  },
  {
    id: "points_for_ryder",
    label: "POINTS FOR RYDER",
    minWidth: 170,
    align: "center",
  },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  id,
  points_for_wholesaler,
  points_for_retailer,
  points_for_ryder
) {
  return {
    id,
    points_for_wholesaler,
    points_for_retailer,
    points_for_ryder,
  };
}

export const AgentsGlobalSettings = () => {
  const [agentsGlobalSettingList, setAgentsGlobalSettingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const fetchAgentsGlobalSetting = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/agent-points/");
      console.log("Agents Global Setting response:", res.data);

      // If API returns single object → wrap it in array
      if (res.data?.status === "success" && res.data?.data) {
        setAgentsGlobalSettingList([res.data.data]);
      } else {
        setError("Failed to fetch Agents Global Setting data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Agents Global Setting data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgentsGlobalSetting();
  }, []);

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("agentGlobal_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("agentGlobal_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("agentGlobal_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("agentGlobal_rowsPerPage", value);
    localStorage.setItem("agentGlobal_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(agentsGlobalSettingList.length / rowsPerPage) - 1
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("agentGlobal_page", 0);
    }
  }, [agentsGlobalSettingList.length, rowsPerPage, loading, page]);

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText">Agents Global Setting</div>
          <div>
            {/* <select className="listAdmin-showRecords">
                  <option>Show No of Records</option>
                  <option>10</option>
                  <option>25</option>
                  <option>50</option>
                  <option>100</option>
                </select> */}
          </div>
          <div className="search-container">
            {/* <div className="nav-search ">
                  <span className="search-icons">
                    <GoSearch />
                  </span>
                  <input type="text" placeholder="Search"></input>
                </div> */}
          </div>
          {/* <div className="btnAdd">
            <button onClick={() => navigate("/ryder-zone-add")}>
              + Add Ryder Zone
            </button>
          </div> */}
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : agentsGlobalSettingList.length > 0 ? (
                  agentsGlobalSettingList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        sx={{
                          backgroundColor:
                            index % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        {columns.map((column) => {
                          let value = row[column.id];
                          const displayValue =
                            value === null ||
                            value === undefined ||
                            value === ""
                              ? "--"
                              : value;

                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className={`${column.id}-column tableCelldata`}
                            >
                              {column.id === "actions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <IconButton sx={{ color: "black" }}>
                                    <EditIcon
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/agents-global-setting-edit/${row.id}`
                                        )
                                      }
                                    />
                                  </IconButton>
                                </div>
                              ) : column.id === "points_for_wholesaler" ? (
                                `${Number(
                                  row.points_for_wholesaler || 0
                                )} Points`
                              ) : column.id === "points_for_retailer" ? (
                                `${Number(row.points_for_retailer || 0)} Points`
                              ) : column.id === "points_for_ryder" ? (
                                `${Number(row.points_for_ryder || 0)} Points`
                              ) : (
                                displayValue
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={agentsGlobalSettingList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
};
